import React, { useState, useEffect, useRef } from 'react';
import styles from './Header.module.css';
import logoImage from './assets/logo2.png';
import { Link } from 'react-router-dom';


function Header() {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  // Dentro del componente:
  const navRef = useRef();

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
    const links = navRef.current.querySelectorAll('a');
    links.forEach((link, index) => {
      if (!isNavVisible) {
        setTimeout(() => link.classList.add(styles.show), 100 * index);
      } else {
        link.classList.remove(styles.show);
      }
    });
  };

  const closeNav = () => {
    setIsNavVisible(false);
    const links = navRef.current.querySelectorAll('a');
    links.forEach((link) => {
      link.classList.remove(styles.show);
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isNavVisible) {
      document.body.style.overflow = 'hidden'; // Evita el desplazamiento del fondo
    } else {
      document.body.style.overflow = 'auto'; // Permite el desplazamiento del fondo
    }
  }, [isNavVisible]);

  // No permitir el scroll horizontal, bloquear
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
  }, []);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''} ${isNavVisible ? styles['menu-open'] : ''}`}>
      <img src={logoImage} alt="Logo" className={styles.logo} />
      <button onClick={toggleNav} className={styles.menuButton}>
        ☰
      </button>
      <nav className={`${styles.nav} ${isNavVisible ? styles.show : ''}`}>
        <ul className={styles.navigation} onClick={closeNav} ref={navRef}>
          <li><Link to="/" className={styles.link}>Inicio</Link></li>
          <li><Link to="/acerca-de#acerca-de" className={styles.link}>Acerca de</Link></li>
          <li><Link to="/contacto#contacto" className={styles.link}>Contáctanos</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
